export default __webpack_public_path__ + "static/media/sv5_en_star_b1.9250a615.mp3";